// extracted by mini-css-extract-plugin
export default {"container":"scaled_container__n+Upq"};